<template>
      <layout-popup
      v-model="isOpen"
      ref="groupIpLayerPopUp"
      :titleName="titleName"
      :confirmEvt="onConfirm"
      :cancelEvt="onCancel"
      :footerBtn="['confirm', 'cancel']"
      :content-css="{minWidth: '700px', minHeight: '270px'}"
    >
      <div>
        <div class="contents-row">
              <!-- 타이틀 시작 -->
          <div class="page-title-1depth">
            <span class="page-title-1depth-text"></span>
          </div>
              <!-- 타이틀 끝 -->
        </div>
        <div class="contents-row">
              <table class="bs-table bs-table table-bordered" style='width:100%'>
                <colgroup>
                  <col width="25%"/>
                  <col width="auto"/>
                </colgroup>
                <tbody>
                  <tr>
                    <td class="td-head">{{$t('cmn.input')}} <span class="textR">*</span></td>
                    <td>
                      <div class="inline-group">
                        <ip-toggle v-if="ccFlag === 1"
                                   ref="adminIpExp"
                                   name="adminIpExp"
                                   v-model="ipType"
                                   :required="true"
                                   :ipv4-value="1"
                                   :ipv6-value="2"
                                   :ip.sync="admin_ip_exp"
                                   class="bs bs-q-ip-input bs-q-ip-input-default bs-q-ip-input-toggle"
                                   style="width: 100%"
                                   :validator="$validator"/>
                        <ip-toggle v-if="ccFlag !== 1"
                                   ref="adminIpExp"
                                   name="adminIpExp"
                                   v-model="ipType"
                                   :required="true"
                                   :ipv4-value="1"
                                   :ipv6-value="2"
                                   :ip.sync="admin_ip_exp"
                                   :mask.sync="ip_exp_prefix"
                                   :ipv4MaskMaxValue="32"
                                   :ipv4MaskMinValue="1"
                                   :prefix-min="1"
                                   :prefix-max="128"
                                   class="bs bs-q-ip-input bs-q-ip-input-default bs-q-ip-input-toggle"
                                   style="width: 100%"
                                   :validator="$validator"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td class="td-head">{{$t('cmn.description')}}</td>
                    <td>
                      <div class="inline-group">
                        <q-input v-model="admin_ip_desc" class="bs bs-q-input bs-q-input-default" style="width:100%;"/>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

        </div>
      </div>
        <validate-dialog ref="validateDialog"/>
    </layout-popup>
</template>
<script>
import {createNamespacedHelpers} from 'vuex'
const {mapState, mapActions} = createNamespacedHelpers('system/adminSettings/adminGroupSettings')
const storeCommon = createNamespacedHelpers('common/common')
import LayoutModalPopUp from '~/components/popUp/LayoutModalPopUp'
import IpToggle from '~/components/control/ipForm/IpToggle'

export default {
  name: 'IpSplitPopup',
  props: {
    fnIsSuper: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'layout-popup': LayoutModalPopUp,
    IpToggle
  },
  data () {
    return {
      isOpen: false,
      datatable: [],
      ipSuperAddMode: false,
      titleName: '',
      admin_ip_exp: '',
      admin_ip_desc: '',
      ipType: 1,
      ip_exp_prefix: 32
    }
  },
  computed: {
    ...mapState([
      'adminIpRange',
      'adminPopupIp',
      'adminIpCurr',
      'adminGeneral'
    ]),
    ...storeCommon.mapState({
      ccFlag: state => state.uiData.system.cc_flag
    })
  },
  methods: {
    ...mapActions([
      'acsPostManagerIp',
      'acsAdminIpCurrConcat',
      'acsSetErrorMessage'
    ]),
    show () {
      this.$refs.groupIpLayerPopUp.show()
      this.resetData()
      this.$validator.reset()
    },
    resetData () {
      this.admin_ip_exp = null
      this.admin_ip_desc = ''
      this.ipType = 1
      this.ip_exp_prefix = 32
    },
    async setIpData () {
      const ipParam = {
        admin_ip: [
          {
            admin_ip_exp: '',
            admin_ip_desc: ''
          }
        ],
        admin_ip_inhrit_yn: 0
      }
      const fixedIp = (this.ipType === 1) ? this.admin_ip_exp + '/32' : this.admin_ip_exp + '/128' // Ipv4 는 netMask 32 고정, Ipv6 는 netMask 128 고정
      ipParam.admin_ip[0].admin_ip_exp = (this.ccFlag !== 1) ? this.admin_ip_exp + '/' + this.ip_exp_prefix : fixedIp // ccFlag 1 일 때는 netMask 를 숨키고 fixedIp 값을 사용하여, netMask 고정 값을 추가한다.
      ipParam.admin_ip[0].admin_ip_desc = this.admin_ip_desc
      const tableData = [{
        admin_id: this.adminGeneral.admin_id,
        admin_ip_id: null,
        admin_ip_start_ip: null,
        admin_ip_end_ip: null,
        admin_ip_exp: ipParam.admin_ip[0].admin_ip_exp,
        admin_ip_desc: ipParam.admin_ip[0].admin_ip_desc
      }]
      const result = await this.acsPostManagerIp({admin_id: this.adminGeneral.admin_id, ip: ipParam})
      if (result === 'ok') {
        this.acsAdminIpCurrConcat(tableData)
        this.$refs.groupIpLayerPopUp.hide()
      }
    },
    async validate () {
      await this.$validator.validateAll()
      if (this.$validator.errors.count() === 0) {
        return true
      }
      this.$refs.validateDialog.show(this.$validator.errors.items)
      return false
    },
    async onConfirm () {
      const result = await this.validate()
      if (result === true) {
        await this.setIpData()
      }
    },
    onCancel () {}
  }
}
</script>
<style scoped>

</style>


